import ImageConverterTemplate from "../components/ImageConverterTemplate";
export default function ConvertPngToIco() {
  return <ImageConverterTemplate sourceFormat="PNG" targetFormat="ICO" acceptTypes=".png,image/png" slug="convert-png-to-ico" gradientColors="from-cyan-500 to-blue-600" accentColor="cyan" />;
}
